import { LabelWrapper } from "./styles"

export const Label = (props) => {
    return (
        <LabelWrapper>{props.children}</LabelWrapper>
    )
}